import { initializeApp, getApps } from 'firebase/app';
import {
  connectAuthEmulator,
  getAuth,
  onIdTokenChanged,
  signInWithCustomToken,
  signOut,
} from 'firebase/auth';
import {
  connectFirestoreEmulator,
  getFirestore,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'demo-ftedn-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'demo-ftedn.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'demo-ftedn',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:892558765278:web:ftedn-team',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'demo-ftedn.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '892558765278',
};

const appName = 'ftedn-team-client';
export const firebaseApp = getApps().find((existingApp) => existingApp.name === appName)
  ?? initializeApp(firebaseConfig, appName);

export const auth = getAuth(firebaseApp);
export const firestoreDb = getFirestore(firebaseApp);

let emulatorConnected = false;
let firestoreEmulatorConnected = false;

function shouldUseEmulators() {
  return import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';
}

if (shouldUseEmulators() && !emulatorConnected) {
  connectAuthEmulator(
    auth,
    import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL || 'http://127.0.0.1:9099',
    { disableWarnings: true },
  );
  emulatorConnected = true;
}

export function connectFirestoreEmulatorIfNeeded() {
  if (!shouldUseEmulators() || firestoreEmulatorConnected) return;

  connectFirestoreEmulator(firestoreDb, '127.0.0.1', 8084);
  firestoreEmulatorConnected = true;
}

export {
  onIdTokenChanged,
  signInWithCustomToken,
  signOut,
};
